import { render, staticRenderFns } from "./servicos.vue?vue&type=template&id=58d816c1&scoped=true&"
import script from "./servicos.vue?vue&type=script&lang=js&"
export * from "./servicos.vue?vue&type=script&lang=js&"
import style0 from "./servicos.vue?vue&type=style&index=0&id=58d816c1&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58d816c1",
  null
  
)

export default component.exports